import { render, staticRenderFns } from "./VStatData.vue?vue&type=template&id=313fe689&"
import script from "./VStatData.vue?vue&type=script&lang=js&"
export * from "./VStatData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports